import { useRouter } from '@tanstack/react-router';
import * as Tooltip from '@radix-ui/react-tooltip';
import { useCreateStore } from '@/entities/create';
interface CreatedEditButtonProps {
    containerClass?: string;
    showTooltip?: boolean;
    tooltipText?: string;
    buttonText?: string;
    styles: {
        button?: string;
        tooltip?: string;
    };
    examName?: string;
    onRefetch?: () => void;
    type?: 'normal' | 'detail';
    icon?: boolean;
    checkList?: DATA.Exam[];
    // detail
    examId?: number;
    exName?: string;
    examSetId?: string;
    publishId?: number;
    curriBook: number;
    subjectId?: number;
    textbookId?: number;
}

export const CreatedEditButton = ({
    showTooltip = false,
    tooltipText = '편집',
    buttonText,
    styles,
    examName,
    type = 'normal',
    icon = false,
    checkList,
    examId,
    examSetId,
    publishId,
    curriBook,
    subjectId,
    textbookId,
}: CreatedEditButtonProps) => {
    const router = useRouter();
    const { setState } = useCreateStore();

    const goEdit = () => {
        setState('type', 'editMode');
        setState('editBackType', type);
        setState('editExamId', examId);
        setState('editExamName', examName + '');
        setState('editExamSetId', examSetId + '');
        setState('sCurribookId', curriBook);
        setState('publishId', publishId ? publishId : undefined);
        setState('editSubjectId', subjectId);
        setState('editTextBookId', textbookId);
        setState('setList', []);
        if (type === 'detail') {
            router.navigate({
                to: `/edit`,
                replace: true,
            });
        } else {
            router.navigate({ to: '/edit' });
        }
    };

    return (
        <>
            {showTooltip ? (
                <Tooltip.Provider>
                    <Tooltip.Root>
                        <Tooltip.Trigger asChild>
                            <button type="button" className={styles.button} onClick={goEdit}>
                                <span className={styles.tooltip ?? 'tooltip'}>{tooltipText}</span>
                                {buttonText && buttonText}
                            </button>
                        </Tooltip.Trigger>
                    </Tooltip.Root>
                </Tooltip.Provider>
            ) : (
                <button
                    type="button"
                    className={styles.button}
                    onClick={goEdit}
                    disabled={type !== 'detail' && checkList && checkList?.length === 0}
                >
                    {icon && <i></i>}
                    {buttonText}
                </button>
            )}
        </>
    );
};
